<script lang="ts">
	import { LoadingSpinner } from "misc-ui"

	interface Props {
		result: boolean
		protocol: "TCP" | "UDP"
		ports: Array<number>
		destination: string
		purpose: string
	}

	let { result, protocol, ports, destination, purpose }: Props = $props()

	let isPending = $derived(result === undefined)
	let isSuccess = $derived(result === true)
	let isFail = $derived(result === false)
</script>

<tr class:isSuccess class:isFail class:isPending>
	<td class="status">
		{#if isPending}
			<LoadingSpinner height="1em" color="var(--color-main)" />
		{:else if isSuccess}
			✔
		{:else}
			✗
		{/if}
	</td>
	<td>
		{protocol}
	</td>
	<td>
		{ports.join(", ")}
	</td>
	<td>
		{destination}
	</td>
	<td class="purpose">
		{purpose}
	</td>
</tr>

<style>
	.status {
		text-align: center;
		vertical-align: middle;
		height: 100%;
	}

	.isFail {
		color: var(--color-error);
	}

	.isSuccess .status {
		color: var(--color-green);
	}

	tr {
		border-top: 1px solid var(--color-border);
	}
</style>
